<template>
  <div class="management" v-if="canView">
    <DxTabPanel
      :selected-index="selectedTab"
      @selected-index-change="selectedTab = $event"
      :items="tabs"
      :show-nav-buttons="true"
      :scroll-by-content="true"
      height="auto"
      class="custom-tab-panel"
    >
      <template #item="{ data }">
        <component :is="data.component" />
      </template>
    </DxTabPanel>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxTabPanel from "devextreme-vue/tab-panel";
import SowedStage from "./partials/SowedStage.vue";
import HarvestedStage from "./partials/HarvestedStage.vue";
import CropRotation from "./partials/CropRotation.vue";
import { canView, permissions, permissionTypes } from "@/helpers/Permissions";
import Forbidden from "@/pages/errors/Forbidden.vue";

export default {
  name: "ManagementBoard",
  data() {
    return {
      selectedTab: 0,
      tabs: [
        { title: this.$t("reporting.management_board.sowed_stage"), component: SowedStage, icon: "fa fa-leaf" },
        { title: this.$t("reporting.management_board.harvested_stage"), component: HarvestedStage, icon: "info" },
        { title: this.$t("reporting.management_board.crop_rotation"), component: CropRotation, icon: "repeat" },
      ],
    };
  },
  components: {
    DxTabPanel,
    SowedStage,
    HarvestedStage,
    CropRotation,
    Forbidden,
  },
  methods: {
    ...mapActions({
      getSeasons: "seasons/getSeasons",
      getDepartments: "company/getDepartments",
    }),
  },
  computed: {
    ...mapGetters({
      seasons: "seasons/seasons",
    }),
    config() {
      return {
        permission: permissions.MANAGEMENT_BOARD,
        permission_type: permissionTypes.module,
      };
    },
    canView() {
      return canView(this);
    },
  },
  mounted() {
    const params = {
      limit: 1000,
      sort: [
        {
          selector: "year",
          desc: true,
        },
      ],
    };
    this.getSeasons(params);
    this.getDepartments({ limit: 1000 });
  },
};
</script>

<style>
.custom-tab-panel .dx-tab {
  font-weight: bold;
  font-size: 16px;
  padding: 10px 24px;
  /* Add more styles as needed */
}

.custom-tab-panel .dx-tab.dx-tab-selected {
  background: #e0e0e0;
  color: #1976d2;
}

.custom-tab-panel .dx-tabs {
  background: #e0e0e0;
  border-radius: 8px 8px 0 0;
}

.custom-tab-panel .dx-tab.dx-tab-selected {
  position: relative;
}

.custom-tab-panel .dx-tab.dx-tab-selected::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  width: 100%;
  background: #4caf50; /* green */
  border-radius: 8px 8px 0 0;
  z-index: 1;
}
</style>
